import React from "react";

import { useAccountingApi } from "../api/accounting.api";

export const useInvoiceDetails = (
  invoiceId?: number,
) => {
  const [ invoiceDetailsResponse, getInvoiceDetailsApi ] = useAccountingApi("GET_INVOICE_DETAILS");

  const fetchInvoice = React.useCallback(() => {
    if (!invoiceId) return;

    getInvoiceDetailsApi(Number(invoiceId));
  }, [ getInvoiceDetailsApi, invoiceId ]);

  React.useEffect(() => {
    fetchInvoice();
  }, [ fetchInvoice ]);

  return {
    invoice: invoiceDetailsResponse.data || null,
    loading: invoiceDetailsResponse.pending,
    error: invoiceDetailsResponse.error,
    refetch: fetchInvoice
  };
};

export default useInvoiceDetails;
